var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.875 25C46.875 12.9188 37.0812 3.125 25 3.125C12.9188 3.125 3.125 12.9188 3.125 25C3.125 37.0812 12.9188 46.875 25 46.875C37.0812 46.875 46.875 37.0812 46.875 25ZM6.25 25C6.25 14.6447 14.6447 6.25 25 6.25C35.3553 6.25 43.75 14.6447 43.75 25C43.75 35.3553 35.3553 43.75 25 43.75C14.6447 43.75 6.25 35.3553 6.25 25ZM23.4375 16.125C23.4375 15.8489 23.6614 15.625 23.9375 15.625H26.0625C26.3386 15.625 26.5625 15.8489 26.5625 16.125V26.0625C26.5625 26.3386 26.3386 26.5625 26.0625 26.5625H23.9375C23.6614 26.5625 23.4375 26.3386 23.4375 26.0625V16.125ZM25 34.375C26.2944 34.375 27.3438 33.3257 27.3438 32.0312C27.3438 30.7368 26.2944 29.6875 25 29.6875C23.7056 29.6875 22.6562 30.7368 22.6562 32.0312C22.6562 33.3257 23.7056 34.375 25 34.375Z",
    fill: "#8C979A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7942_27695",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 44,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.875 25C46.875 12.9188 37.0812 3.125 25 3.125C12.9188 3.125 3.125 12.9188 3.125 25C3.125 37.0812 12.9188 46.875 25 46.875C37.0812 46.875 46.875 37.0812 46.875 25ZM6.25 25C6.25 14.6447 14.6447 6.25 25 6.25C35.3553 6.25 43.75 14.6447 43.75 25C43.75 35.3553 35.3553 43.75 25 43.75C14.6447 43.75 6.25 35.3553 6.25 25ZM23.4375 16.125C23.4375 15.8489 23.6614 15.625 23.9375 15.625H26.0625C26.3386 15.625 26.5625 15.8489 26.5625 16.125V26.0625C26.5625 26.3386 26.3386 26.5625 26.0625 26.5625H23.9375C23.6614 26.5625 23.4375 26.3386 23.4375 26.0625V16.125ZM25 34.375C26.2944 34.375 27.3438 33.3257 27.3438 32.0312C27.3438 30.7368 26.2944 29.6875 25 29.6875C23.7056 29.6875 22.6562 30.7368 22.6562 32.0312C22.6562 33.3257 23.7056 34.375 25 34.375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7942_27695)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#FF8049"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.cec83177ed966f042f1407dd14407d3e.svg";
export { ForwardRef as ReactComponent };